export const USER_TAG_OFFICIAL = 1
export const USER_TAG_PREMIUM = 2

export function toUserTag(tag) {
	const n = Number(tag)
	return Number.isFinite(n) ? n : 0
}

export function isOfficialUserTag(tag) {
	return toUserTag(tag) === USER_TAG_OFFICIAL
}

export function isPremiumUserTag(tag) {
	return toUserTag(tag) === USER_TAG_PREMIUM
}

export function hasUserTagImg(img) {
	return !!(img && String(img).trim())
}

export function pickUserTagInfo(sources) {
	let userTag
	let userTagImg = ''
	const list = Array.isArray(sources) ? sources : []
	for (let i = 0; i < list.length; i++) {
		const src = list[i]
		if (!src) {
			continue
		}
		if (userTag == null && src.userTag != null) {
			userTag = src.userTag
		}
		if (!hasUserTagImg(userTagImg) && hasUserTagImg(src.userTagImg)) {
			userTagImg = src.userTagImg
		}
		if (userTag != null && hasUserTagImg(userTagImg)) {
			break
		}
	}
	return {
		userTag: userTag == null ? 0 : userTag,
		userTagImg: userTagImg || ''
	}
}
